export default __webpack_public_path__ + "static/media/PolySubStuff.9dd43954.svg";